import app from 'app';
import FileUpload from 'v/UploadView/FileUpload.vue';
import AssetGalleryModal from 'v/AssetGalleryModal.vue';
import storyViewBus from '../storyViewBus';
import WtFaceOnCamera from 'components/modals/types/wtFaceOnCamera/wtFaceOnCamera.component.vue';
// import WtVoiceRecorder from 'components/modals/types/wtFaceOnCamera/wtVoiceRecorder.component.vue';
import WtVoiceRecorder from 'components/modals/types/wtFaceOnCamera/wtVoiceRecorderPackageWraper.vue';
import ModuleAssetGallery from '#/store/module/assetGallery.vuex';

export default function (extend) {
  /**
   use _this to access api instance
   use this to access vue instance
   */
  const api = {
    uploadQueue: [],

    _connectAssetGalleryStore: function () {
      if (!app.rootStore.state.assetGallery) {
        app.rootStore.registerModule('assetGallery', ModuleAssetGallery, {
          preserveState: false,
        });
        app.rootStore.dispatch('INIT_ASSET_GALLERY_MODULE');
      }
    },

    addMoreMedia: _.debounce(
      function (e) {
        if (e) {
          e.preventDefault();
        }

        storyViewBus.$emit('svbPauseRcp');

        this._connectAssetGalleryStore();

        app
          .showModal({
            type: 'overlay',
            component: AssetGalleryModal,
            showCloseButton: false,
            closeOnEscape: true,
            closeOnClickOut: false,
          })
          .$on('close', () => {
            app.rootStore.unregisterModule('assetGallery');
          });
      },
      app.TIME.MENTAL.λ,
      { leading: true, trailing: false }
    ),

    showMediaUploadView: function (options) {
      options = $.extend(
        {
          initEvent: null,
          analyticsData: null,
        },
        options || {}
      );

      app
        .showModal({
          type: 'normal',
          store: app.rootStore,
          component: FileUpload,
          componentPropsData: {
            validateVideoDuration: true,
            initEvent: options.initEvent,
            analyticsData: options.analyticsData,
            allowAudioFiles:
              !app.rootStore.getters['user/isImpededTemplatizer'],
          },
          backdrop: true,
          closeOnClickOut: false,
        })
        .$on('close', (res) => {
          if (!res.uqModels?.length) {
            return;
          }
          if (res.redirectToAssetGallery) {
            const models = [...res.uqModels];
            _.each(models, (model) => {
              const isNarration =
                model.options.uploadType === app.uploadType.NARRATION_ASSET;
              const uploadDestination = isNarration
                ? app.uploadDestination.LIGHTBOX
                : app.uploadDestination.ASSET_GALLERY;
              app.rootStore.dispatch('ESCORT_UPLOADING_ASSET', {
                uploadDestination,
                isNarration,
                asset: model.attributes,
              });
            });
            this.gotoMyMedia();
          } else {
            _.each(res.uqModels, (model) => {
              const isNarration =
                model.options.uploadType === app.uploadType.NARRATION_ASSET;
              app.rootStore.dispatch('ESCORT_UPLOADING_ASSET', {
                uploadDestination: app.uploadDestination.LIGHTBOX,
                isNarration,
                asset: model.attributes,
              });
            });
          }
        });
    },

    showAudioRecordView: function (options) {
      app
        .showModal({
          type: 'normal',
          component: WtVoiceRecorder,
          wrapperClass: ['wt-voice-recorder-container'],
          componentPropsData: {
            source: 'Lightbox',
            storyId: options.storyId,
            analyticsData: options.analyticsData,
            voiceId: options.voiceId,
            transcript: options.transcript,
            aiVoiceSpeed: options.aiVoiceSpeed,
          },
          backdrop: true,
          closeOnClickOut: false,
          showCloseButton: false,
          closeOnEscape: false,
        })
        .$on('close', (res) => {
          if (options.asset) {
            storyViewBus.$emit('lightboxAssetPreviewClosed', {
              asset: options.asset,
            });
          }
          if (res) {
            if (res.asset) {
              app.rootStore.dispatch('ASSET_SELECTED', {
                asset: res.asset,
                isNarration: true,
              });
            } else if (res.blob) {
              app.handleNarrationRecordResponse({
                blob: res.blob,
                caption: res.caption,
                title: res.fileName,
                isLightbox: true,
                modelProps: res.modelProps,
                transcript: res.caption,
              });
            }
          }
        });
    },

    gotoAssetSearch: function (e) {
      _this._connectAssetGalleryStore();
      _this.addMoreMedia(e);
    },

    gotoMyMedia: function (e) {
      _this._connectAssetGalleryStore();
      app.rootStore.dispatch('SET_ASSETS_SOURCE', {
        source: app.assetsSource.NORMAL,
        search: true,
      });
      if (app.isEmbedded) {
        _this._startWith(app.PROVIDERS.KALTURA.id);
      } else {
        _this._startWith(app.PROVIDERS.MY_GALLERY.id);
      }
      _this.addMoreMedia(e);
    },

    gotoWallpaper(asset) {
      app
        .showModal({
          component: 'wt-add-wallpaper',
          type: 'big',
          componentPropsData: { asset: asset, mode: asset ? 'replace' : 'add' },
        })
        .$on('close', (wallpaperObj) => {
          if (
            wallpaperObj &&
            wallpaperObj.newWallpaper &&
            (wallpaperObj.oldId || wallpaperObj.oldName)
          ) {
            storyViewBus.$emit(
              'svbTimelineHandleWallpaperReplace',
              wallpaperObj
            );
          }
        });
    },

    gotoFaceOnCamera() {
      app
        .showModal({
          type: 'normal',
          component: WtFaceOnCamera,
          wrapperClass: ['wt-face-on-camera-container'],
          componentPropsData: {
            source: 'Lightbox',
            useSpeechRecognition: false,
          },
          backdrop: true,
          closeOnClickOut: false,
          showCloseButton: false,
          closeOnEscape: false,
        })
        .$on('close', (res) => {
          if (res && res.blob) {
            app.handleFaceOnCameraResponse({
              blob: res.blob,
              caption: res.caption,
              isLightbox: true,
              autoTranscribe: res.autoTranscribe,
            });
          }
        });
    },

    shouldAbortKeyBoard(e) {
      return (
        (!this.$el.contains(e.target) && $(e.target).isEditable()) ||
        $('.modal.wt-dialog').is(':visible') ||
        $('.modal.wt-modal').is(':visible') ||
        $('.modal-backdrop').is(':visible') ||
        $('.wt2-modal').is(':visible')
      );
    },

    isPristine() {
      return _this._isLightBoxEmpty() && !_this._uploadingToLightbox();
    },

    _isLightBoxEmpty: function () {
      const selectedAssets = app.rootStore.state.story.selectedAssets || [];
      const voiceOverSegments =
        app.rootStore.state.story.selectedVoiceOverSegments || [];
      const uploading = _this.uploadQueue || [];

      return (
        selectedAssets.length + voiceOverSegments.length + uploading.length ===
        0
      );
    },

    _uploadingToLightbox: function () {
      return !(
        _.isEmpty(app.rootStore.state.story.lightboxUploadingAssets) &&
        _.isEmpty(app.rootStore.state.story.lightboxUploadingVoiceOverAssets)
      );
    },

    _startWith(id) {
      app.rootStore.commit('changeSearchContext', { id, initialValue: '' });
    },
  };

  // extend
  const _this = Object.assign({}, api, extend);

  // export
  return _this;
}
